exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".create-branch .users-select {\n  margin-top: 0; }\n  .create-branch .users-select label {\n    color: #777777; }\n\n.create-branch .users-select > div::after {\n  border-bottom: 2px solid #777777; }\n\n@media only screen and (max-width: 600px) {\n  .create-branch .new-branch-filed {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/clients/detail/branches/add/index.scss
// module id = 1237
// module chunks = 0